const dashboardActionTypes = {
  STORE_DASHBOARD_DATA: 'STORE_DASHBOARD_DATA',
};

export default dashboardActionTypes;
